import * as types from "~/store/partnerUser/types";

export const createPartnerUser = id => {
  return {
    type: types.CREATE_PARTNER_USER,
    id
  };
};
